import { tss } from 'tss-react';

import { getNumberString } from 'functions/numberToString';
import useCultureCode from 'hooks/redux/useCultureCode';
import useCurrency from 'hooks/redux/useCurrency';
import useTranslation from 'hooks/useTranslation';

export type Data = {
	id: string;
	name: string;
	store: string;
	gtin: string;
	quantity: number;
	price: number;
};

interface IProps {
	data: Data[];
	total: number;
}

const Receipt = (props: IProps) => {
	const { classes, cx } = useStyles();
	const cultureCode = useCultureCode();
	const { t } = useTranslation();
	const currency = useCurrency();

	const renderProduct = (product: Data): JSX.Element => {
		const price = product.price;
		return (
			<div key={product.id} className={classes.marginBottom10}>
				<div className="row">
					<div className="col-md-6 d-flex flex-column">
						<span>{product.name}</span>
						<span className={classes.fontSize12}>-{product.store}-</span>
						<span className={cx(classes.fontSize12, classes.fontStyleItalic)}>
							{product.store === 'Default' ? '***' : product.gtin}
						</span>
					</div>
					<span className="col-md-3">
						{product.quantity}&times; <br></br>
						{product.price > 0 ? <span>{price.toFixed(2)}</span> : <span>0</span>}
					</span>
					<span className="col-md-3">
						{price > 0 ? (
							<span>{(product.quantity * product.price).toFixed(2)}</span>
						) : (
							<span>0</span>
						)}{' '}
						{currency}
					</span>
				</div>
				<hr className={classes.hrSpecial} />
			</div>
		);
	};

	return (
		<div className={classes.container}>
			<h4 className={classes.h4}>{t('shoppingCart:RECEIPT')}</h4>
			<hr className={classes.hr} />
			<div className={classes.list}>
				{props.data.map((product) => renderProduct(product))}
			</div>
			<hr className={classes.hr} />
			<div className={classes.total}>
				<span>{t('shoppingCart:ESTIMATED_BILL')}</span>
				<span>
					{getNumberString(props.total, cultureCode)} {currency}
				</span>
			</div>
		</div>
	);
};

export default Receipt;

const useStyles = tss.create({
	container: {
		fontFamily: 'monospace',
		padding: '20px',
		margin: '10px auto',
		border: '1px dashed #000',
		backgroundColor: 'white',
	},
	h4: {
		textAlign: 'center',
		marginBottom: '12px',
	},
	hr: {
		borderTop: '1px dashed #000',
	},
	hrSpecial: {
		borderTop: '1px dashed #000',
		margin: '5px 0',
	},
	list: {
		minHeight: '22rem',
		maxHeight: '34rem',
		overflowY: 'auto',
		overflowX: 'hidden',
		paddingRight: '8px',
		fontSize: '14px',
	},
	total: {
		display: 'flex',
		justifyContent: 'space-between',
		fontWeight: 'bold',
		marginTop: '20px',
	},
	fontSize12: {
		fontSize: '12px',
	},
	fontStyleItalic: {
		fontStyle: 'italic',
	},
	marginBottom10: {
		marginBottom: '10px',
	},
});
